import { SortingState } from "@tanstack/react-table";
import { PAGE_SEARCH_PARAMETER } from "constants/common";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import useDebouncedValue from "./useDebouncedValue";
import useSearchParameter from "./useSearchParameter";

interface ManageTableParams {
  defaultSorting: SortingState;
  defaultSearchValue?: string | null;
  pageSearchParameter?: string;
}

const useManageTable = (params?: Partial<ManageTableParams>) => {
  const [searchValue, setSearchValue] = useState(
    params?.defaultSearchValue ?? ""
  );
  const debouncedSearch = useDebouncedValue<string>(searchValue, 500);
  const [sorting, setSorting] = useState<SortingState>(
    params?.defaultSorting ?? []
  );
  const [page, setPage] = useSearchParameter(
    params?.pageSearchParameter ?? PAGE_SEARCH_PARAMETER
  );

  const [showDeletedOnly, setShowDeletedOnly] = useState(false);

  useEffect(() => {
    setPage(1);
  }, [showDeletedOnly]);

  useEffect(() => {
    if (debouncedSearch) {
      setPage(1);
    }
  }, [debouncedSearch]);

  return {
    searchValue,
    setSearchValue,
    debouncedSearch,
    sorting,
    page: Number(page) || 1,
    setSorting,
    setPage,
    showDeletedOnly,
    setShowDeletedOnly
  };
};

export default useManageTable;
